import React, { useEffect, useState, useCallback } from "react";
import "./Lenders.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import { url } from "../../../../../App";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Typography,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DescriptionIcon from "@mui/icons-material/Description";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CloseIcon from "@mui/icons-material/Close";
// import Tooltip from '@mui/material/Tooltip';

const Lenders = ({ loanData }) => {
  // eslint-disable-next-line
  const [open, setOpen] = useState(false);
  const [user, setuser] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [kcplData, setKcplData] = useState({});
  const [modalData, setModalData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [actionStatus, setActionStatus] = useState({});
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const [borrowerKYCdocumentType, setborrowerKYCdocumentType] = useState("AADHAAR");
  const [CoapplicantdocumentType, setCoapplicantdocumentType] = useState("AADHAAR");
  const [LoanApplicationdocumentType, setLoanApplicationdocumentType] = useState("BANK_STATEMENT");
  // eslint-disable-next-line
  const [borrowerIndividualModalData, setBorrowerIndividualModalData] = useState([]);
  // eslint-disable-next-line
  const [coapplicantIndividualModalData, setCoapplicantIndividualModalData] = useState([]);
  // eslint-disable-next-line
  const [loanApplicationIndividualModalData, setLoanApplicationIndividualModalData] = useState([]);
  // eslint-disable-next-line
  const [individualModalType, setIndividualModalType] = useState(null);
  const [isbuttonClicked, setIsButtonClicked] = useState({});
  const [completedSections, setCompletedSections] = useState({
    ki: false,
    loan: false,
    pre: false,
    decision: false,
    post: false,
    disb: false
  });
  const [latestLoanStatus, setLatestLoanStatus] = useState(null);

  // Define the sequential order of sections
  // const sectionOrder = ["ki", "loan", "pre", "decision", "post", "disb"];
  const cheackLoanStatus = async () => {
    setOpen(true);
    try {
      const res = await axios.post(url + "/loan/kcpl/checkLoanStatus", {
        loanID: loanData?.loan_id,
        email,
        token,
        borrowerID: loanData?.borrower_uniqueno
      });

      if (res.data.auth) {
        // setKcplData(res.data.message);
        setLatestLoanStatus(res.data.message);
        window.location.reload();
      }
    } finally {
      setOpen(false);
    }
  }

  useEffect(() => {
    axios
      .post(url + "/user/getsingle", {
        token: token,
        email: email,
        useremail: email
      })
      .then((res) => {
        console.log(res?.data?.[0]);
        setuser(res?.data?.[0]);
      })
      .catch((err) => {
        console.log(err);
      })
  }, [email, token]);

  useEffect(() => {
    const latest =
      kcplData?.ApplicationStatus?.at(-1)?.ResponseInfo;

    if (latest) {
      setLatestLoanStatus(latest);
    }
  }, [kcplData]);


  // const isSectionEnabled = (sectionKey) => {
  //   const index = sectionOrder.indexOf(sectionKey);

  //   // First section is always allowed
  //   if (index === 0) return true;

  //   // All previous sections must be completed
  //   for (let i = 0; i < index; i++) {
  //     if (!completedSections[sectionOrder[i]]) {
  //       return false;
  //     }
  //   }
  //   return true;
  // };

  const getLatest = (arr) => arr?.[arr?.length - 1];

  const fetchDetails = useCallback(async () => {
    console.log("user-> ", user)
    setOpen(true);
    try {
      const res = await axios.post(url + "/loan/kcpl/allDetails", {
        loanID: loanData.loan_id,
        email,
        token
      });

      if (res.data.auth) {
        setKcplData(res.data.message);
      }
    } finally {
      setOpen(false);
    }
    // eslint-disable-next-line
  }, [loanData.loan_id, email, token]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);
  // useCallback(() => {
  //   fetchDetails();
  // }, [cheackLoanStatus])

  // MODIFIED: Allow opening any accordion freely, no restrictions
  const handleAccordionChange = (panel) => (_, isExpanded) => {
    // Remove the section enabled check - allow opening any accordion
    setExpanded(isExpanded ? panel : false);
  };

  // const getSectionName = (sectionKey) => {
  //   const names = {
  //     ki: "Ki Score",
  //     loan: "Loan Application Details",
  //     pre: "Pre-Sanction Documents",
  //     decision: "Lender Decision",
  //     post: "Post Sanction Documents",
  //     disb: "Disbursement"
  //   };
  //   return names[sectionKey] || sectionKey;
  // };

  const callApi = async (key, api, body, successMsg, sectionKey) => {
    try {
      if (user?.email !== "rupesh.bishnoi@credin.in" && user?.permission?.call_ki_score_api === false) {
        toast.error("You don't have permission to perform this action!");
        return;
      }

      // // Check if section is enabled before calling API
      // if (sectionKey && !isSectionEnabled(sectionKey)) {
      //   toast.error(`Complete "${getSectionName(sectionOrder[sectionOrder.indexOf(sectionKey) - 1])}" step first before calling ${getSectionName(sectionKey)}`);
      //   return;
      // }

      setIsButtonClicked((prev) => ({ ...prev, [key]: true }));
      setActionStatus((prev) => ({
        ...prev,
        [key]: "pending"
      }));

      setOpen(true);

      const res = await axios.post(url + api, { ...body, token: token, email: email });

      if (res.data.auth) {
        setActionStatus((prev) => ({
          ...prev,
          [key]: "success"
        }));

        // Update completed sections if sectionKey is provided
        if (sectionKey) {
          setCompletedSections((prev) => ({
            ...prev,
            [sectionKey]: true
          }));
        }

        toast.success(successMsg);
      } else {
        setActionStatus((prev) => ({
          ...prev,
          [key]: "error"
        }));

        toast.error(res.data.message);
      }
    } catch (e) {
      setActionStatus((prev) => ({
        ...prev,
        [key]: "error"
      }));

      toast.error("API failed");
    } finally {
      fetchDetails();
      setOpen(false);
      // Reset button clicked state after a delay
      setTimeout(() => {
        setIsButtonClicked((prev) => ({ ...prev, [key]: false }));
      }, 1000);
    }
  };

  const openResponseModal = (data) => {
    setModalData(data || []);
    setSelectedResponse(null);
    setModalOpen(true);
    setIndividualModalType(null);
  };

  const openIndividualResponseModal = (data, type) => {
    setModalData(data || []);
    setSelectedResponse(null);
    setModalOpen(true);
    setIndividualModalType(type);
  };

  const ActionRow = ({ label, onClick, data, actionKey, disabled, sectionKey }) => {
    const latest = getLatest(data);
    const liveStatus = actionStatus[actionKey];
    const isButtonClicked = isbuttonClicked[actionKey];

    // Check if this section is enabled for calling APIs
    // const isSectionEnabledForCall = sectionKey ? isSectionEnabled(sectionKey) : true;


    const getStatusClass = () => {
      if (liveStatus === "pending") return "pending";
      if (liveStatus === "success") return "success";
      if (liveStatus === "error" || latest?.FaildResponse) return "error";
      return latest ? "success" : "idle";
    };

    const getStatusText = () => {
      if (liveStatus === "pending") return "Pending";
      if (liveStatus === "success") return "Success";
      if (liveStatus === "error") return "Failed";
      return latest ? "Success" : "Not Started";
    };

    // Button is disabled if:
    // 1. It's explicitly disabled prop
    // 2. API call is pending
    // 3. Previous sections are not completed (sequence enforced)
    // const isDisabled = disabled || liveStatus === "pending" || !isSectionEnabledForCall;
    const isDisabled = disabled || liveStatus === "pending";
    return (
      <div className="action-row">
        <Button
          className="primary-btn"
          onClick={onClick}
          disabled={isDisabled}
        // title={!isSectionEnabledForCall ? `Complete "${getSectionName(sectionOrder[sectionOrder.indexOf(sectionKey) - 1])}" step first` : ""}
        >
          {label} {isButtonClicked ? "Re-Trigger" : ""}
        </Button>

        <div className="status-block">
          <span className={`status-dot ${getStatusClass()}`} />
          <Typography variant="caption">{getStatusText()}</Typography>
        </div>

        {/* Response button is ALWAYS enabled - users can view responses anytime */}
        <IconButton onClick={() => openResponseModal(data)}>
          <DescriptionIcon />
        </IconButton>

        {latest?.receivedAt && (
          <Typography className="time">
            Last: {new Date(latest.receivedAt).toLocaleTimeString()}
          </Typography>
        )}
      </div>
    );
  };

  const IndividualDocRow = ({ label, docType, docCategory, individualData, actionKey, sectionKey }) => {
    const latest = getLatest(individualData);
    // console.log("latest-> ",latest)
    const liveStatus = actionStatus[actionKey];
    console.log("latest-> ",latest)

    // const isSectionEnabledForCall = sectionKey ? isSectionEnabled(sectionKey) : true;

    const getStatusClass = () => {
      if (liveStatus === "pending") return "pending";
      if (liveStatus === "success") return "success";
      if (liveStatus === "error" || latest?.FaildResponse) return "error";
      return latest ? "success" : "Not Started";
    };

    const getStatusText = () => {
      if (liveStatus === "pending") return "Pending";
      if (liveStatus === "success") return "Success";
      if (liveStatus === "error") return "Failed";
      return latest ? "Success" : "Not Started";
    };

    return (
      <div className="dropdown-row">
        <Typography className="dropdown-label">
          Select Document Type
        </Typography>

        <select
          value={docType.value}
          onChange={(e) => docType.setter(e.target.value)}
          className="doc-dropdown"
          // disabled={!isSectionEnabledForCall}
          disabled={false}
        >
          {docType.options.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>

        <div className="status-block" style={{ marginLeft: '10px' }}>
          <span className={`status-dot ${getStatusClass()}`} />
          <Typography variant="caption">{getStatusText()}</Typography>
        </div>

        {/* Response button is ALWAYS enabled - users can view responses anytime */}
        <IconButton onClick={() => openIndividualResponseModal(individualData, docCategory)}>
          <DescriptionIcon />
        </IconButton>

        {latest?.receivedAt && (
          <Typography className="time">
            Last: {new Date(latest.receivedAt).toLocaleTimeString()}
          </Typography>
        )}

        <Button
          sx={{ borderRadius: '10px', marginLeft: '10px' }}
          variant="outlined"
          // disabled={!isSectionEnabledForCall}
          disabled={false}
          // title={!isSectionEnabledForCall ? `Complete previous steps first` : ""}
          onClick={() =>
            callApi(
              actionKey,
              "/loan/kcpl/individual/docs/upload",
              {
                loanID: loanData.loan_id,
                borrowerID: loanData?.borrower_uniqueno,
                docType: docType?.value,
                sancationType: "PRE",
                docCategory: docCategory
              },
              "Push Individual",
              sectionKey
            )
          }
        >
          Push Individual
        </Button>
      </div>
    );
  };


  return (
    <>
      <ToastContainer />

      <div className="container">
        {/* KI SCORE */}
        <Accordion expanded={expanded === "ki"} onChange={handleAccordionChange("ki")}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <InfoIcon className="section-icon" />
            <Typography>Ki Score</Typography>
            {completedSections.ki && <Chip label="Completed" size="small" color="success" sx={{ ml: 2 }} />}
          </AccordionSummary>
          <AccordionDetails>
            <ActionRow
              label="Check Ki Score"
              actionKey="kiScore"
              data={kcplData?.kcplScore}
              disabled={false}
              sectionKey="ki"
              onClick={() =>
                callApi(
                  "kiScore",
                  "/loan/kcpl/kiscore",
                  {
                    loanID: loanData?.loan_id,
                    borrowerID: loanData?.borrower_uniqueno
                  },
                  "KI Score fetched",
                  "ki"
                )
              }
            />
          </AccordionDetails>
        </Accordion>

        {/* LOAN DETAILS */}
        <Accordion expanded={expanded === "loan"} onChange={handleAccordionChange("loan")}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <DescriptionIcon className="section-icon" />
            <Typography>Loan Application Details</Typography>
            {completedSections.loan && <Chip label="Completed" size="small" color="success" sx={{ ml: 2 }} />}
          </AccordionSummary>
          <AccordionDetails>
            <ActionRow
              label="Push Application Details"
              actionKey="createLoan"
              data={kcplData?.LoanAapplicationDetails}
              sectionKey="loan"
              onClick={() =>
                callApi("createLoan", "/loan/kcpl/createLoan", {
                  loanID: loanData?.loan_id,
                  borrowerID: loanData?.borrower_uniqueno
                }, "Loan pushed", "loan")
              }
            />
          </AccordionDetails>
        </Accordion>

        {/* PRE SANCTION */}
        <Accordion expanded={expanded === "pre"} onChange={handleAccordionChange("pre")}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <InsertDriveFileIcon className="section-icon" />
            <Typography>Pre-Sanction Documents</Typography>
            {completedSections.pre && <Chip label="Completed" size="small" color="success" sx={{ ml: 2 }} />}
          </AccordionSummary>

          <AccordionDetails>
            <ActionRow
              label="Push Borrower KYC"
              actionKey="BorrowerKYC"
              data={kcplData?.BorrowerKYC}
              sectionKey="pre"
              onClick={() =>
                callApi(
                  "BorrowerKYC",
                  "/loan/kcpl/bulkUpload/BorrowerDocs",
                  {
                    loanID: loanData?.loan_id,
                    borrowerID: loanData?.borrower_uniqueno
                  },
                  "Borrower docs sent",
                  "pre"
                )
              }
            />

            <IndividualDocRow
              label="Individual Document"
              docType={{
                value: borrowerKYCdocumentType,
                setter: setborrowerKYCdocumentType,
                options: [
                  { value: "AADHAAR", label: "AADHAAR POI" },

                  // { value: "SALARY_SLIP", label: "Salary Slip" } SELF_IMAGES
                  { value: "AADHAAR_POA", label: "AADHAAR POA" },
                  // { value: "VOTER_CARD", label: "Voter Card" },

                  // { value: "SELF_IMAGES", label: "Self Photo" },
                  // { value: "BANK_STATEMENT", label: "Bank Statement" }

                ]
              }}
              docCategory="BorrowerDoc"
              individualData={kcplData?.BorrowerKYCIndividual}
              actionKey="borrowerIndividual"
              sectionKey="pre"
            />

            <ActionRow
              label="Push Co-applicant KYC"
              actionKey="coappDocs"
              data={kcplData?.CoapplicantKYC}
              sectionKey="pre"
              onClick={() =>
                callApi(
                  "coappDocs",
                  "/loan/kcpl/uploadCoapplicantKYCdoc",
                  {
                    loanID: loanData?.loan_id,
                    borrowerID: loanData?.borrower_uniqueno
                  },
                  "Co-applicant docs sent",
                  "pre"
                )
              }
            />

            <IndividualDocRow
              label="Individual Document"
              docType={{
                value: CoapplicantdocumentType,
                setter: setCoapplicantdocumentType,
                options: [
                  { value: "AADHAAR", label: "AADHAAR POI & POA" },
                  // { value: "PAN", label: "PAN" },
                  { value: "VOTER_CARD", label: "Voter Card" },
                  // { value: "FORM_60", label: "FORM 60 Card" },
                  // { value: "SELF_IMAGES", label: "Self photo" },
                  // { value: "BANK_STATEMENT", label: "Bank Statement" },

                ]
              }}
              docCategory="CoApplicantKyc"
              individualData={kcplData?.CoapplicantKYCIndividual}
              // individualData={fals€€€e}

              actionKey="coapplicantIndividual"
              sectionKey="pre"
            />

            <ActionRow
              label="Push Loan Application Docs"
              actionKey="loanDocs"
              data={kcplData?.LoanAapplicationDocs}
              sectionKey="pre"
              onClick={() =>
                callApi(
                  "loanDocs",
                  "/loan/kcpl/uploadKYCdoc",
                  {
                    loanID: loanData?.loan_id,
                    borrowerID: loanData?.borrower_uniqueno
                  },
                  "Loan docs sent",
                  "pre"
                )
              }
            />

            <IndividualDocRow
              label="Individual Document"
              docType={{
                value: LoanApplicationdocumentType,
                setter: setLoanApplicationdocumentType,
                options: [
                  { value: "PAN", label: "Applicant PAN" },
                  { value: "CO_PAN", label: "CO-Applicant PAN" },
                  { value: "BANK_STATEMENT", label: "Bank Statement" },
                  { value: "MILK_STATEMENT", label: "Milk Statement" },
                  { value: "BUSINESS_IMAGES", label: "Business Images" },
                  { value: "SELF_IMAGES", label: "Applicant Self Photo" },
                  { value: "CO_SELF_IMAGES", label: "CO-Applicant Self Photo" },
                  { value: "CPV", label: "CPV" },
                  { value: "CO_FORM_60", label: "FORM 60" },
                  { value: "RESIDENCE_IMAGES", label: "Residence Images" },
                  { value: "OWNERSHIP", label: "Electricity Bill" },
                ]
              }}
              docCategory="LoanApplication"
              individualData={kcplData?.LoanAapplicationDocsIndividual}
              actionKey="loanApplicationIndividual"
              sectionKey="post"
            />
          </AccordionDetails>
        </Accordion>

        {/* LENDER DECISION */}
        <Accordion
          expanded={expanded === "decision"}
          onChange={handleAccordionChange("decision")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <CheckCircleIcon className="section-icon" />
            <Typography>Lender Decision (Check Loan Status)</Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

              {/* Check Status Button */}
              {/* <Box>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ borderRadius: 4 }}
                  onClick={cheackLoanStatus}
                >
                  Check Status
                </Button>
              </Box> */}

              <ActionRow
                label="Check Loan Status"
                actionKey="Loan Status"
                data={kcplData?.ApplicationStatus}
                disabled={false}
                sectionKey="status"
                onClick={cheackLoanStatus}
              />

              {/* Latest response */}
              {latestLoanStatus && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    marginTop: "10px"
                  }}
                >
                  {latestLoanStatus.loanId && (
                    <div>
                      <strong>KCPL Loan ID:</strong>{" "}
                      {latestLoanStatus.loanId}
                    </div>
                  )}

                  {latestLoanStatus.partnerLoanId && (
                    <div>
                      <strong>Credin Loan ID:</strong>{" "}
                      {latestLoanStatus.partnerLoanId}
                    </div>
                  )}

                  {latestLoanStatus.reasonForRejection && (
                    <div>
                      <strong>Reason For Rejection:</strong>{" "}
                      {latestLoanStatus.reasonForRejection}
                    </div>
                  )}

                  {latestLoanStatus.nextSteps && (
                    <div>
                      <strong>Next Steps:</strong>{" "}
                      {latestLoanStatus.nextSteps}
                    </div>
                  )}
                </div>
              )}
            </Box>
          </AccordionDetails>
        </Accordion>
        {/* <Accordion expanded={expanded === "decision"} onChange={handleAccordionChange("decision")}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <CheckCircleIcon className="section-icon" />
            <Typography>Lender Decision (Check Loan Status)</Typography>
            {console.log("ApplicationStatus-> ", kcplData?.ApplicationStatus?.at(-1)?.ResponseInfo)}
            {kcplData?.ApplicationStatus && <Chip label="Completed" size="small" color="success" sx={{ ml: 2, mr: 2 }} />}
          </AccordionSummary>
          <AccordionDetails >
            <Tooltip title="Application Status">
              <Chip
                label={kcplData?.ApplicationStatus?.at(-1)?.ResponseInfo?.applicationStatus || "Pending"}
                className="recommended"
                color={kcplData?.ApplicationStatus?.at(-1)?.ResponseInfo?.applicationStatus === "Approved" ? "success" : "warning"}
              />
            </Tooltip>
            <Tooltip title="Ki Score">
              <Chip
                label={kcplData?.ApplicationStatus?.at(-1)?.ResponseInfo?.kiScore || "Pending"}
                className="recommended"
                sx={{ ml: 2 }}
              />
            </Tooltip>
            <Tooltip title="Next Steps">

              <Chip
                label={kcplData?.ApplicationStatus?.at(-1)?.ResponseInfo?.nextSteps || "Pending"}
                className="recommended"
                sx={{ ml: 2 }}

              />
            </Tooltip>
            <Tooltip title="Reason For Rejection">

              <Chip
                label={kcplData?.ApplicationStatus?.at(-1)?.ResponseInfo?.reasonForRejection || "Pending"}
                className="recommended"
                sx={{ ml: 2 }}

              />
            </Tooltip>
            <Tooltip title="Reviewer Remarks">

              <Chip
                label={kcplData?.ApplicationStatus?.at(-1)?.ResponseInfo?.reviewerRemarks || "Pending"}
                className="recommended"
                sx={{ ml: 2 }}

              />
            </Tooltip>

            {/* Button to mark decision as completed (if needed) */}
            {/* {kcplData?.webhook?.reverse()[0]?.ResponseInfo?.status === "Approved" && !completedSections.decision && ( */}
            {/* <IconButton sx={{ m: 2 }} >
              <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{ ml: 2, borderRadius: 4 }}
                onClick={cheackLoanStatus}
              >
                Check Status
              </Button>
            </IconButton>
            <DescriptionIcon variant="contained"
              color="primary"
              size="small"
              onClick={() => openIndividualResponseModal(kcplData?.ApplicationStatus, "pre")}
            /> */}
            {/*  )} */}
          {/* </AccordionDetails>
        </Accordion> */}

        {/* POST SANCTION DOCUMENTS */}
        <Accordion expanded={expanded === "post"} onChange={handleAccordionChange("post")}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <InsertDriveFileIcon className="section-icon" />
            <Typography>Post Sanction Documents</Typography>
            {completedSections.post && <Chip label="Completed" size="small" color="success" sx={{ ml: 2 }} />}
          </AccordionSummary>

          <AccordionDetails>
            <ActionRow
              label="Push KFS/Sanction Letter"
              actionKey="kfs"
              data={kcplData?.KFSSactionLetter}
              sectionKey="post"
              onClick={() =>
                callApi(
                  "kfs",
                  "/loan/kcpl/individual/docs/upload",
                  {
                    loanID: loanData.loan_id,
                    borrowerID: loanData.borrower_uniqueno,
                    sancationType: "POST",
                    docCategory: "KFSSactionLetter"
                  },
                  "Push Individual",
                  "post"
                )
              }
            />

            <ActionRow
              label="Push KFS audit trail"
              actionKey="kfsAuditTrailPost"
              data={kcplData?.KfsAuditTrail}
              sectionKey="post"
              onClick={() =>
                callApi(
                  "agreementPost",
                  "/loan/kcpl/individual/docs/upload",
                  {
                    loanID: loanData?.loan_id,
                    borrowerID: loanData?.borrower_uniqueno,
                    sancationType: "POST",
                    docCategory: "KFSAuditTrail"
                  },
                  "Push Individual",
                  "post"
                )
              }
            />

            <ActionRow
              label="Push Loan Agreement"
              actionKey="agreementPost"
              data={kcplData?.LoanAgreement}
              sectionKey="post"
              onClick={() =>
                callApi(
                  "agreementPost",
                  "/loan/kcpl/individual/docs/upload",
                  {
                    loanID: loanData?.loan_id,
                    borrowerID: loanData?.borrower_uniqueno,
                    sancationType: "POST",
                    docCategory: "Agreement"
                  },
                  "Push Individual",
                  "post"
                )
              }
            />

            <ActionRow
              label="Push Agreement Audit Trail"
              actionKey="agreementAuditTrailPost"
              data={kcplData?.AgreementAuditTrail}
              sectionKey="post"
              onClick={() =>
                callApi(
                  "agreementPost",
                  "/loan/kcpl/individual/docs/upload",
                  {
                    loanID: loanData?.loan_id,
                    borrowerID: loanData?.borrower_uniqueno,
                    sancationType: "POST",
                    docCategory: "AgreementAuditTrail"
                  },
                  "Push Individual",
                  "post"
                )
              }
            />

            <ActionRow
              label="Push NACH Document"
              actionKey="nach"
              data={kcplData?.NACHDocs}
              sectionKey="post"
              onClick={() =>
                callApi(
                  "nach",
                  "/loan/kcpl/individual/docs/upload",
                  {
                    loanID: loanData?.loan_id,
                    borrowerID: loanData?.borrower_uniqueno,
                    sancationType: "POST",
                    docCategory: "NACH"
                  },
                  "Push Individual",
                  "post"
                )
              }
            />
          </AccordionDetails>
        </Accordion>

        {/* DISBURSEMENT */}
        <Accordion expanded={expanded === "disb"} onChange={handleAccordionChange("disb")}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <AccountBalanceWalletIcon className="section-icon" />
            <Typography>Disbursement</Typography>
            {completedSections.disb && <Chip label="Completed" size="small" color="success" sx={{ ml: 2 }} />}
          </AccordionSummary>
          <AccordionDetails>
            <ActionRow
              label="Disbursement Request"
              actionKey="disbursement"
              data={kcplData?.Disbursement}
              sectionKey="disb"
              onClick={() =>
                callApi(
                  "disbursement",
                  "/loan/kcpl/UploadADRDetails",
                  {
                    loanID: loanData?.loan_id,
                    borrowerID: loanData?.borrower_uniqueno
                  },
                  "Disbursement triggered",
                  "disb"
                )
              }
            />
          </AccordionDetails>
        </Accordion>
      </div>

      {/* RESPONSE MODAL */}
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          API Responses {individualModalType && `- ${individualModalType}`}
          <IconButton onClick={() => setModalOpen(false)} className="close-btn">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {!modalData || modalData?.length === 0 ? (
            <Typography>No responses available</Typography>
          ) : (
            <div className="response-container">
              <div className="response-list">
                {[...modalData].reverse().map((item, i) => (
                  <div
                    key={i}
                    className={`response-list-item ${selectedResponse === ([...modalData]?.length - 1) - i ? "active" : ""}`}
                    onClick={() => setSelectedResponse(([...modalData]?.length - 1) - i)}
                  >
                    <Typography variant="caption">
                      {new Date(item?.receivedAt)?.toLocaleString()}
                    </Typography>
                  </div>
                ))}
              </div>

              <div className="response-view">
                {selectedResponse !== null && modalData[selectedResponse] ? (
                  <pre>
                    {JSON.stringify(modalData[selectedResponse], null, 2)}
                  </pre>
                ) : (
                  <Typography>Select a response to view details</Typography>
                )}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Lenders;